import React from 'react';
import './Map.css';
import cx from 'classnames';
const map_default = new URL('./graphics/map--default.jpg', import.meta.url);

const Map = ({ type = "default" }) => {

    // define variables
    const blurAmount = (type === 'default') ? 0 : 25;

    // define classes
    const classes = cx(
        `map`,
        (type === 'blur') && 'type-blur'
    )

    // render html
    return(
        <div className={classes}>
            <div className={`map__inner`}>
                <div className={`map__canvas`}>
                    <img src={map_default} alt="map" />
                </div>
            </div>
        </div>
    );

}

export default Map;